import classNames from 'classnames';

import { Box } from '@hivebrite/design-system/Box';
import { Dotdotdot } from '@hivebrite/design-system/Dotdotdot';

import { DefaultLink } from 'hb-react/frontoffice/components/Link';
import * as mobileDeviceFromUserAgent from 'helpers/mobileDeviceFromUserAgent';

import style from './index.module.scss';

const Partner = ({
  logo_medium_url: logoMediumUrl,
  name,
  description,
  url,
}) => {
  const mobileView = !!mobileDeviceFromUserAgent.any();
  const content = (
    <>
      <img
        alt={name}
        className="user-item__img push-half--bottom"
        src={logoMediumUrl}
      />
      <Dotdotdot clamp={2}>
        <div className="h5 flush color-dark-gray break-word">{name}</div>
      </Dotdotdot>
    </>
  );

  return (
    <Box
      className={classNames(style.component, {
        'one-half': mobileView,
        'soft-half--sides': mobileView,
        'one-quarter': !mobileView,
        'soft-quarter--sides': !mobileView,
      })}
      mb={8}
      display="inline-block"
      verticalAlign="top"
      textAlign="center"
      data-toggle="tooltip"
      data-toggle-cursor="none"
      data-title={description}
    >
      {url ? (
        <DefaultLink href={url} target="_blank">
          {content}
        </DefaultLink>
      ) : (
        <div>{content}</div>
      )}
    </Box>
  );
};

export default Partner;
